<template>
  <div id="content" class="crpg-o-free-stay-free-stay-content campaign_3">
    <div id="detail" class="crpg-o-free-stay-free-stay-content__detail">
      <AtomsCommonFreeTopTitle :title01="content.topTitle.topTitle01" :title02="content.topTitle.topTitle02" :title03="content.topTitle.topTitle03" :title04="content.topTitle.topTitle04" />
      <div class="coupon">
        <h4 style="text-indent: 0">【無料宿泊ご招待券見本】</h4>
        <p><img :src="contentTopImage" /></p>
      </div>
      <div class="note">
        <h4 style="text-indent: 0">【申込期間】</h4>
        <p>{{ content.notePeriod }}</p>
      </div>
      <div class="note">
        <MoleculesFreeFoodFInfo :note="content.note" />
      </div>
      <!--  3/18リリースの修正で一旦なしとの指示。一旦とのことなのでコメントアウトとする -->
      <!-- <div
        class="hotel_detail"
        v-for="item in content.hotelPlanDate"
        :key="item.image"
      >
        <MoleculesFreeStayHotelPlan
          :image="item.image"
          :area="item.area"
          :name="item.name"
          :catchcopy="item.catchcopy"
          :puroductNo="item.puroductNo"
          :roomType="item.roomType"
        />
      </div> -->
      <div id="list">
        <div class="title-l">■対象宿泊施設一覧</div>
        <MoleculesFreeStayHotelList />
        <MoleculesFreeStayHotelRightsExchange />
      </div>
      <!--  3/18リリースの修正で一旦なしとの指示。一旦とのことなのでコメントアウトとする -->
      <!-- <div class="attention">
        <ul>
          <li v-for="item in content.groupListTextDate" :key="item.groupListText">
            {{ item.groupListText }}
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>
<script>
import AtomsCommonFreeTopTitle from "@/components/atoms/common/FreeTopTitle.vue";
import text from "@/assets/txt/free_stay.json";
import MoleculesFreeFoodFInfo from "@/components/molecules/freeFood/Info.vue";
// import MoleculesFreeStayHotelPlan from "@/components/molecules/freeStay/HotelPlan.vue";
import MoleculesFreeStayHotelList from "@/components/molecules/freeStay/HotelList.vue";
import MoleculesFreeStayHotelRightsExchange from "@/components/molecules/freeStay/HotelRigthsExchange.vue";

var textDate = text;
export default {
  name: "PgFreeFood",
  components: {
    AtomsCommonFreeTopTitle,
    MoleculesFreeFoodFInfo,
    // MoleculesFreeStayHotelPlan,
    MoleculesFreeStayHotelList,
    MoleculesFreeStayHotelRightsExchange,
  },
  data() {
    return {
      content: textDate,
      contentTopImage: require("@/assets/img/stay_coupon.jpg"),
    };
  },
};
</script>
<style lang="scss">
@import "@/assets/css/organisms/freeStay/freeStayContent.scss";
</style>
